export const displayArray = (value, letter) => {
  const joinLetter = letter ? letter : ', ';

  return value.join(joinLetter);
};

const toArray = (value) => {
  if (value === null || value === undefined) {
    return [];
  }
  return Array.isArray(value) ? value : [value];
};

export { toArray };
